// Multivariate Dependencies
import React from 'react';
// Components
import { Container } from '../../../common/styles/container';
import { Paragraph } from '../../../atoms/Paragraph';
// Types
import { TextCellEnums } from '../types/TextCellProps';
export var TextCellStructure = function (_a) {
    var value = _a.value, className = _a.className;
    return (React.createElement(Container, { className: className, as: 'td' },
        React.createElement(Paragraph, { size: 'small', truncateText: true }, value || TextCellEnums.DEFAULT_VALUE)));
};
//# sourceMappingURL=TextCellStructure.js.map